import { adminGet } from "../../http";
import { SettingConfigData } from "../../../types/Setting/SettingConfigData";

export const searchAnimatedImage = async (
  query: string,
  config: SettingConfigData | null
): Promise<{ link_url: string; thumbnail_url: string }[]> => {
  return adminGet(
    "announcements/animated_image_search",
    { query: query },
    { requireUser: true, config }
  );
};
